import React from "react";
import Avatar from "../Avatar/Avatar";
import "./User.scss";

import PropTypes from "prop-types";

export const AvatarSize = {
    Big: "Big",
    Medium: "Medium",
    Small: "Small"
};

const UserHz = (props) => {
    let sizeClassName = "";
    if (props.size === AvatarSize.Small)
        sizeClassName = " small";
    return (
        <div className="d-flex align-items-center">
            <div className={"user" + sizeClassName}><Avatar name={props.name} avatar={props.avatar} /></div>
            <div className="ml-2">
                <h5 className="card-text text-wrap">{props.name}</h5>
                <h6 className="card-text text-break">{props.title}</h6>
            </div>
        </div>
    );
}

UserHz.defaultProps = {
    size: AvatarSize.Medium
}

UserHz.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    avatar: PropTypes.string,
    size: PropTypes.oneOf(Object.values(AvatarSize))
};

export default UserHz;